var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-toggle"},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.selected},on:{"change":_vm.handleChange}}),_c('span',{staticClass:"slider round",class:{
        'cursor-pointer': !_vm.disabled,
        'slider--disabled': _vm.disabled && !_vm.selected,
      }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }